import * as React from 'react';

function SvgSignage(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M13 19v2.5h2V23H9v-1.5h2V19h2zm7-16a2 2 0 012 2v11a2 2 0 01-2 2H4a2 2 0 01-2-2V5c0-1.1.9-2 2-2h16zm0 1.5H4a.5.5 0 00-.5.41V16c0 .25.18.45.41.5H20a.5.5 0 00.5-.41V5a.5.5 0 00-.41-.5H20zm-5.27 3l3.77 3.58-1.04 1-2.02-1.93V14h-1.42v-3.85L12 12.07l-2.02-1.92V14H8.56v-3.85l-2.02 1.92-1.04-.99L9.27 7.5 12 10.1l2.73-2.6z" />
    </svg>
  );
}

export default SvgSignage;
